/**
 * The member app lives on a separate origin/domain, so these are plain
 * external links (no react-router) — deliberately not env-driven since this
 * marketing site has no build-time knowledge of the app deployment.
 */
export const REGISTER_URL = 'https://app.alphaone.group/register';
export const LOGIN_URL = 'https://app.alphaone.group/login';
